"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ModalContent_1 = __importDefault(require("./ModalContent"));
exports.default = ModalContent_1.default;
